/**
 * Header component
 *
 * Top navigation bar for your site. Set to remain visible as the
 * user scrolls so that they can constantly reach any part of your page.
 */
import React from "react";

const Header = () => {
  return (
    <div
      style={{
        position: "fixed",
        display: "flex",
        justifyContent: "center",
        gap: "2rem",
        background: "rgba(13, 17, 23, 0.85)",
        backdropFilter: "blur(12px)",
        padding: "0.875rem 2rem",
        top: 0,
        width: "100%",
        zIndex: 10,
        borderBottom: "1px solid rgba(48, 54, 61, 0.6)",
      }}
    >
      <a href="#home" style={{ color: "#F0F6FC", fontWeight: 500, fontSize: "0.95rem" }}>Home</a>
      <a href="#about" style={{ color: "#F0F6FC", fontWeight: 500, fontSize: "0.95rem" }}>About</a>
      <a href="#portfolio" style={{ color: "#F0F6FC", fontWeight: 500, fontSize: "0.95rem" }}>Portfolio</a>
      <a href="#footer" style={{ color: "#F0F6FC", fontWeight: 500, fontSize: "0.95rem" }}>Contact</a>
    </div>
  );
};

export default Header;
